import React from 'react';
import { BigHead } from '@bigheads/core';

/**
 * Customizable character to be displayed on website
 */
export const Avatar = ({
    avatarBackgroundColor = '#b0d1b9',
    accessory = 'none',
    body = 'chest',
    clothing = 'shirt',
    clothingColor = 'green',
    eyebrows = 'raised',
    eyes = 'normal',
    faceMask = false,
    faceMaskColor = 'white',
    facialHair = 'none',
    graphic = 'redwood',
    hair = 'none',
    hairColor = 'black',
    hat = 'none',
    hatColor = 'red',
    lashes = false,
    lipColor = 'red',
    mouth = 'openSmile',
    skinTone = 'light',
    mask = false, // Optional if we decide to use this
    width,
    height,
}) => {
    return (
        <div
            className={`background overflow-hidden ${width ? `w-${width}` : 'w-baseAvatarCont xs:w-xsAvatarCont'} ${height ? `h-${height}` : 'h-baseAvatarCont xs:h-xsAvatarFrame'}`}

            style={{
                backgroundColor: avatarBackgroundColor,
            }}>
            <BigHead
                accessory={accessory}
                body={body}
                clothing={clothing}
                clothingColor={clothingColor}
                eyebrows={eyebrows}
                eyes={eyes}
                faceMask={faceMask}
                faceMaskColor={faceMaskColor}
                facialHair={facialHair}
                graphic={graphic}
                hair={hair}
                hairColor={hairColor}
                hat={hat}
                hatColor={hatColor}
                lashes={lashes}
                lipColor={lipColor}
                mouth={mouth}
                skinTone={skinTone || 'light'}
                mask={false}
            />
        </div>
    );
};
